import React from "react";
import heart from "../../assets/img/heart.webp";
const Footer = () => {
  return (
    <footer className="footer">
      <h4 className="footerTitle">
        Made with love
        <img className="footerImg" src={heart} alt="coeur dans une main" />
      </h4>
    </footer>
  );
};

export default Footer;
